import { render, staticRenderFns } from "./MantleSystemRecommended.vue?vue&type=template&id=0f6ddd23&scoped=true"
import script from "./MantleSystemRecommended.vue?vue&type=script&lang=js"
export * from "./MantleSystemRecommended.vue?vue&type=script&lang=js"
import style0 from "./MantleSystemRecommended.vue?vue&type=style&index=0&id=0f6ddd23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6ddd23",
  null
  
)

export default component.exports